<script>
	// Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';	
</script>

<section class="conteudo-internas">
	<PageHeader title={titlePage}></PageHeader>
	<div class="container text-justify">
		<p>As exigências legais, trabalhistas e previdenciárias entre outros comprometimentos do condomínio, tornam necessário o acompanhamento por profissionais qualificados para assessoramento nestas questões. Para isso, a SP Imobiliária possui profissionais exclusivamente treinados para estas tarefas, os quais constantemente fazem cursos de aperfeiçoamento, tentando aprimorar ainda mais o atendimento, garantindo maior satisfação, tranqüilidade e segurança a todos os condôminos e buscando a redução dos custos condominiais.</p>
		<div class="gridbox size--2 md-size--1 mt-40">
			<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
				<div class="media-left flex-grid">
					<span class="media-object fa-stack fa-3x">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-handshake-o fa-stack-1x fa-inverse"></i>
					</span>
				</div>
				<div class="media-body">
					<h3 class="color-primary">Serviços terceirizados</h3>
					<p>A SP Imobiliária poderá indicar empresas terceirizadas que podem ser contratadas para execução de serviços nos condomínios nas áreas de limpeza, manutenção e segurança, ficando responsável pelo pagamento de todos os encargos trabalhistas. Poderá indicar outros profissionais qualificados para atender as necessidades de cada condomínio.</p>
				</div>
			</div>
			<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
				<div class="media-left flex-grid">
					<span class="media-object fa-stack fa-3x">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-files-o fa-stack-1x fa-inverse"></i>
					</span>
				</div>
				<div class="media-body">
					<h3 class="color-primary">Prestação de contas</h3>
					<p>Está sempre à disposição dos condôminos para consulta na imobiliária, com a movimentação diária do condomínio. Se preferirem, os clientes podem ainda, receber em casa, pelo correio ou por e-mail um relatório mensal com todas as despesas e receitas.</p>
				</div>
			</div>
			<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
				<div class="media-left flex-grid">
					<span class="media-object fa-stack fa-3x">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-cloud fa-stack-1x fa-inverse"></i>
					</span>
				</div>
				<div class="media-body">
					<h3 class="color-primary">Acesso on-line</h3>
					<p>Os condôminos têm acesso as informações condominiais tais como, extratos e balancetes de conta, emissão de segunda via de boletos, atas das assembleias, entre outras. Para o síndico são disponibilizados relatórios de inadimplentes.</p>
				</div>
			</div>
			<div class="gridbox size--120-fr md-size--1 gap--10 xs-gap--v10">
				<div class="media-left flex-grid">
					<span class="media-object fa-stack fa-3x">
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-print fa-stack-1x fa-inverse"></i>
					</span>
				</div>
				<div class="media-body">
					<h3 class="color-primary">Facilidade de pagamento</h3>
					<p>A cobrança do condomínio e encargos é feita através de boleto bancário, podendo ser pago em qualquer banco, agência lotérica, via internet e ainda através de débito automático nos Bancos do Brasil e Banrisul. Há a disponibilidade de 2ª via de boletos no site.</p>
				</div>
			</div>
		</div>
		<h2 class="title color-primary mt-35 mb-20 text-center">Sistema de trabalho</h2>
		<p>Dentre os serviços prestados na contratação da Administração de Condomínios podemos citar:</p>
		<ul style="line-height: 30px;">
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Emissão de recibos de contribuição mensal e cobrança;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Controle de fluxo de caixa;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Controle e pagamentos das contas;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Gerência das despesas mensais;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Elaboração e distribuição mensais de prestação de contas quando solicitado;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Elaboração e distribuição de circulares, convocações e demais correspondências;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> O Controle de pessoal, administração dos pagamentos de salários e encargos e acompanhamento de mudanças na legislação trabalhista, quando contratado;</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> Dispomos de assessoria jurídica para esclarecimento das dúvidas condominiais, além de possuirmos contato direto com o setor jurídico da AGADEMI (Associação Gaúcha de Empresas do Mercado Imobiliário), onde poderemos efetuar consultas dos assuntos mais polêmicos.</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> O acompanhamento dos serviços de manutenção, quando necessário, a administração da compra de materiais necessários à execução destes serviços, bem como os habitualmente adquiridos pelo condomínio, poderão ser feitos pela SP Imobiliária.</li>
			<li><i class="fas fa-check-circle mr-10 color-primary"></i> A SP Imobiliária dispõe de auditório e salas para a realização das assembleias condominiais, com projetores, mesa de som, microfones, todas com estrutura de cozinha, banheiros, inclusive para deficientes físicos.</li>
		</ul>
		<hr>
		<div class="text-center" style="font-weight: bold;">
			<p>Decisões pertinentes ao condomínio repercutem na vida de várias pessoas, e é por isso que precisam ser bem planejadas.</p>
			<p>A SP Imobiliária busca através de um trabalho profissional adequá-las as reais necessidades de cada conjunto habitacional.</p>
		</div>
		<hr>
		<p>Clique abaixo para solicitar uma proposta de serviços para o seu condomínio e descubra a diferença que é ter a nossa experiência trabalhando a favor de menores custos e mais qualidade nos serviços.</p>
		<div class="button mt-40 text-center">        
			<a href="/solicite-proposta" use:link replace title="" class="btn btn-secondary">
				Solicite uma proposta <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
			</a>
		</div>        

	</div>
</section>

<style type="text/sass">

.card-border
	padding: 20px
	display: flex
	align-items: center
	flex-direction: column
	h2
		font-size: 16px
	p 
		font-size: 12px
		line-height: 120%

</style>
